import $ from "jquery";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

$(function() {
    $(".bl-testimonials").each(function() {
        initBlock($(this));
    });
});

function initBlock($bl) {
    fillTestimonials($bl);
    initSwiperDesktop($bl);
    initSwiperMobile($bl);
}

function initSwiperDesktop($bl) {
    const $ctrtestimonials = $bl.find(".ctrtestimonials-desktop");
    const $ctrpagination = $bl.find(".ctrpagination-desktop");
    
    const swiper = new Swiper($ctrtestimonials.find(".swiper").get(0), {
      //loop: true,
      //rewind: true,
      autoHeight: false,
      
      pagination: {
        el: $ctrpagination.get(0),
        clickable: true
      },

      /*
      navigation: {
        prevEl: $ctrswipernavigation.find(".icon-arrowleft").get(0),
        nextEl: $ctrswipernavigation.find(".icon-arrowright").get(0),
      },
      */

      /*
      speed: 1500,
      autoplay: {
        delay: 4000
      }
      */

      spaceBetween: 100
    });
}


function initSwiperMobile($bl) {
    const $ctrtestimonials = $bl.find(".ctrtestimonials-mobile");
    const $ctrpagination = $bl.find(".ctrpagination-mobile");
    
    const swiper = new Swiper($ctrtestimonials.find(".swiper").get(0), {
      //loop: true,
      //rewind: true,
      autoHeight: true,
      
      pagination: {
        el: $ctrpagination.get(0),
        clickable: true
      },

      /*
      navigation: {
        prevEl: $ctrswipernavigation.find(".icon-arrowleft").get(0),
        nextEl: $ctrswipernavigation.find(".icon-arrowright").get(0),
      },
      */

      /*
      speed: 1500,
      autoplay: {
        delay: 4000
      }
      */

      spaceBetween: 100
    });
}

function fillTestimonials($bl) {
    // Get testimonials from template
    var $template = $bl.find('template.testimonials');
    var $testimonials = $template.contents().filter('.testimonial');

    var $desktopWrapper = $bl.find('.ctrtestimonials-desktop .swiper-wrapper');
    var $mobileWrapper  = $bl.find('.ctrtestimonials-mobile .swiper-wrapper');

    /* =====================
       DESKTOP (4 per slide)
    ====================== */
    for (var i = 0; i < $testimonials.length; i += 4) {
        var $slide = $('<div class="swiper-slide testimonialslide"></div>');

        $testimonials.slice(i, i + 4).each(function () {
            $slide.append($(this).clone());
        });

        $desktopWrapper.append($slide);
    }

    /* =====================
       MOBILE (1 per slide)
    ====================== */
    $testimonials.each(function () {
        var $slide = $('<div class="swiper-slide"></div>');
        $slide.append($(this).clone());
        $mobileWrapper.append($slide);
    });
}

